import { t } from 'i18next';
import { APIHeader } from '..';
import { errorNotification } from '../reducers/handle-api-status/slice';
import { getDownloadLink } from '../utils';

export async function onDownloadExecutingFileClick(
  uiURL,
  pecrId,
  siteId,
  departmentId,
  eIndex,
  filename,
  dispatch
) {
  try {
    const response = await fetch(`${uiURL}api/DownloadExecutingFile`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId,
        departmentId,
        index: eIndex,
        //this pecrid is added in some places and not in others
        pecrId: pecrId,
        filename,
      }),
    });
    const blob = await response.blob();
    getDownloadLink(blob, filename);
  } catch (error) {
    dispatch(
      errorNotification({
        hasErrorOccured: true,
        message: t('error_message'),
      })
    );
  }
}
